export default {
  discount_types: {
    cashback: 'Loyalty points',
    promo_code: 'Promo code',
  },
  input: {
    label: '{{cashbackLabel}} or {{promoCodeLabel}}',
    placeholder: 'Promo code',
  },
  buttons: {
    apply: 'Apply',
    remove: 'Remove',
  },
  feedback: {
    login:
      "<highlight>Log in</highlight> to use this promo so we can make sure you haven't used it yet. Login and try again.",
    usage_threshold: 'Minimum basket amount for this promo is (excl. delivery costs)',
    promo_code_added: 'Promo code successfully applied',
  },
};
